<template>
  <div>
    <cards
      :id="order.client.id"
      @input="changeCard"
      v-model="order.card_id"
      :card="order.card"
    />
    <div class="install-control">
      <button @click="send" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  watch: {
    "order.card": {
      handler: function (val) {
        try {
          this.data.card = val.card_number
            ? val.card_number.replace(/\s+/g, "")
            : "";

          this.data.expire = val.exp ? val.exp.replace("/", "") : "";
        } catch (error) {}
      },
      deep: true,
    },
  },
  components: {
    Cards: () => import("@/components/Item/Order/Client/Cards"),
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {},
  methods: {
    async changeCard(val) {
      await this.updateOrder({ card_id: val });
    },
    send() {
      let data = {
        app_id: this.transaction.exchange_id
          ? parseInt(this.transaction.exchange_id)
          : parseInt(this.value.data.app_id),

        // card: this.data.card,
        card_number: this.data.card,
        expire: this.data.expire,
      };

      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}application/add/card`,
        method: "POST",
        data: data,
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.data) {
            this.createTransaction({
              step: "application-scoring",
            });
            this.$emit("setStep", "application-scoring");
            this.$emit("input", response.data);
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 500);
        });
    },
  },
  data() {
    return {
      data: {
        card: null,
        expire: null,
      },
    };
  },
};
</script>

